import { withInstall } from '@tni-plus/utils'

import BasicHelp from './src/help.vue'

export const TpHelp = withInstall(BasicHelp)

export * from './src/help'

export type { HelpInstance } from './src/instance'
